import { theme } from 'modules/ui/theme';
import { Label } from 'modules/ui/typography';
import { mediaQuery } from 'modules/utils';
import styled from 'styled-components';

export const SubmenuContainer = styled.div`
  display: flex;
  width: 100%;

  flex-direction: column;
  justify-content: space-between;

  min-height: 90vh;

  padding: 1rem;

  ${mediaQuery('md')} {
    padding: 0;
    border-top: 1px solid ${({theme}) => theme.colors.primaryK2};
    margin-top: 0.625rem;
    padding-top: 0.963rem;

    min-height: 1.5rem;
    justify-content: center;
    align-items: center;
  }
`;

export const StyledSubmenuItem = styled(Label)<{ selected?: boolean }>`
  font-size: ${theme.fontSizes.h3};
  text-transform: none;
  border-bottom: solid 3px transparent;
  margin-bottom: 2rem;
  text-decoration: var(--text-underline);
  
  // On mobile screens, submenu has a dark theme.
  color: ${({theme}) => theme.colors.primaryK3};

  cursor: pointer;

  ${mediaQuery('md')} {
    color: ${({theme}) => theme.colors.primaryK10};;
    margin-bottom: 0;
    text-transform: uppercase;
    font-size: ${theme.fontSizes.h5};
    transition: border-bottom 0.15s linear;
    line-height: var(--h3-line-height);
    padding: 0rem 1rem 0rem 1rem;

    ${(props) =>
      props.selected &&
      ` color: ${props.theme.colors.primaryT2};
        border-bottom: solid 3px ${props.theme.colors.primaryT2};
    `}

    &:hover {
      color: ${({theme}) => theme.colors.primaryK7};
    }
    ${(props) =>
      props.selected &&
      `
        &:hover {
          color: ${props.theme.colors.primaryT1} ;
          border-bottom: solid 3px ${props.theme.colors.primaryT1} 
        }
      `}
  }
`;

export const SubmenuItemContainer = styled.div`
  display: flex;
  flex-direction: column;

  ${mediaQuery('md')} {
    flex-direction: row;
    justify-content: center;
    align-items: center;
    max-width: 40rem;

    width: 100%;
    gap: 1rem;
  }
`;

export const SubmenuMobileButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  border-top: 1px solid ${({theme}) => theme.colors.primaryK2};
  padding-top: 1.5rem;

  & > *:not(:last-child) {
    margin-right: 2rem;
  }

  ${mediaQuery('md')} {
    display: none;
  }
`;
